import React, { Fragment } from "react";

import { Grid, makeStyles } from "@material-ui/core";
import { Skeleton } from "@material-ui/lab";

import { OverallProgressSkeletonProps } from "./types";

const useStyles = (dark: boolean) =>
  makeStyles(theme => ({
    skeleton: {
      backgroundColor: dark ? "#B0BEC5" : "rgba(0, 0, 0, 0.04)",
      margin: theme.spacing(1),
    },
    overallPercentageProgressBar: {
      width: "100%",
    },
  }));

const OverallProgressSkeleton: React.FC<OverallProgressSkeletonProps> = ({
  dark = false,
}) => {
  const classes = useStyles(dark)();
  return (
    <Fragment>
      <Grid container direction="row" justify="space-between">
        <Grid container item direction="column" xs={3} sm={2} md={1}>
          <Skeleton
            variant="rect"
            width="85%"
            height={55}
            className={classes.skeleton}
          />
        </Grid>
        <Grid
          container
          item
          direction="row"
          xs={9}
          sm={10}
          md={11}
          justify="center"
          alignItems="center"
        >
          <Skeleton
            variant="text"
            width="85%"
            height={55}
            className={classes.skeleton}
          />
        </Grid>
      </Grid>
    </Fragment>
  );
};

export default OverallProgressSkeleton;
